import { isAfter, isBefore, isEqual } from 'date-fns'

import { FullCalendarEventData } from './types'

const areEventsOverlapping = (event: FullCalendarEventData, nextEvent: FullCalendarEventData) =>
  (isBefore(new Date(nextEvent.startDate), new Date(event.endDate)) ||
    isEqual(new Date(nextEvent.startDate), new Date(event.endDate))) &&
  (isAfter(new Date(nextEvent.endDate), new Date(event.startDate)) ||
    isEqual(new Date(nextEvent.endDate), new Date(event.startDate)))

export const sortEvents = (events: FullCalendarEventData[]): FullCalendarEventData[] => {
  // Sort events by start date first for predictable position assignments
  return [...events]
    .sort((a, b) => {
      return new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
    })
    .reduce<FullCalendarEventData[]>((positionedEvents, event) => {
      const overlappingPositions = positionedEvents
        .filter((positionedEvent) => areEventsOverlapping(positionedEvent, event))
        .map((positionedEvent) => positionedEvent.position)

      let position = 1
      while (overlappingPositions.includes(position)) position += 1

      return [...positionedEvents, { ...event, position }]
    }, [])
}
